import React from "react";
import BookSectionTitle from "../shop/BookSectionTitle";
import BookItem from "../../components/shop/BookItem";

const hasItemDescription = (item) =>
  Array.isArray(item?.description) && item.description.length > 0;

const BookSection = ({ title, titleJP, id, isTitleBGYellow, items }) => {
  const safeItems = Array.isArray(items) ? items : [];
  const anyHasDescription = safeItems.some(hasItemDescription);
  const bookListClassName = `book-list${anyHasDescription ? " with-descriptions" : ""}`;

  return (
    <div className="shop-list-section">
      <div className="container shop-main-section">
        <section id={id} className="pronunciation-section">
          <BookSectionTitle
            title={title}
            subTitle={titleJP}
            type={isTitleBGYellow ? "yellow" : ""}
          />
          <div className={bookListClassName}>
            {safeItems.length > 0 &&
              safeItems.map((item, key) => (
                <BookItem
                  key={key}
                  title={item.title}
                  subTitle={item.subtitle}
                  image={item.image}
                  bookTitle={item.bookTitle}
                  price={item.price}
                  link={item.link}
                  linkText={item.linkText}
                  description={item.description}
                />
              ))}
          </div>

          <hr className="bottom-line" />
        </section>
      </div>
    </div>
  );
};

export default BookSection;
